import { render, staticRenderFns } from "./TreatmentItemsSetTable.vue?vue&type=template&id=b59628e0&scoped=true&"
import script from "./TreatmentItemsSetTable.vue?vue&type=script&lang=js&"
export * from "./TreatmentItemsSetTable.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentItemsSetTable.vue?vue&type=style&index=0&id=b59628e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59628e0",
  null
  
)

export default component.exports